import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Grid, IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { activeServiceData } from "assets/properties/properties";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { whiteListIPConfig } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
const WhiteListIPMasterCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [name, setName] = useState("");
  const [disabledButton, setDisabledButton] = useState(true);
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [enabledSerive, setEnabledService] = useState("");
  const [whiteListIP, setWhiteListIP] = useState([""]);
  const [branchCodeList, setBranchCodeList] = useState([]);

  useEffect(() => {
    getAllBranchDetails();
  }, []);

  const getAllBranchDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_ALL_BRANCH,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setBranchCodeList(result?.data);
      if (params?.id) {
        getIdData();
      }
    }
  };
  
  const getIdData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_BY_ID_IP_WHITE_LIST_MASTER + params?.id,
      authToken: authToken,
    });
    setCallInProgress(false);
    if(result?.data?.error_code){
      toastUpdate(toastAction?.error,result?.data?.user_description,true);
    }else{
      setName(result?.data?.branchCode);
      setEnabledService(result?.data?.enabled);
      if(result?.data?.whitelistedIps?.length > 0){
        setWhiteListIP(result?.data?.whitelistedIps || [""]);
      }else{
        setWhiteListIP([""]);
      }
    }
  };

  useEffect(() => {
    const isEnabled = enabledSerive === true || enabledSerive === "true";
    
    const isWhiteListValid =
      whiteListIP?.length > 0 && whiteListIP.every((ip) => ip.trim() !== "");
    
    const isBranchSelected = !!name;
    
    if (isEnabled) {
      if (isBranchSelected && isWhiteListValid) {
        setDisabledButton(false);
      } else {
        setDisabledButton(true);
      }
    } else if (enabledSerive === false || enabledSerive === "false") {
      if (isBranchSelected) {
        setDisabledButton(false);
      } else {
        setDisabledButton(true);
      }
    } else {
      setDisabledButton(true);
    }
  }, [name, enabledSerive, whiteListIP]);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };

  const editInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.UPDATE_IP_WHITE_LIST_MASTER + params?.id,
      method: "PUT",
      authToken: authToken,
      data: {
        branchCode: name,
        enabled: enabledSerive,
        whitelistedIps: whiteListIP,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  
  const saveInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.CREATE_IP_WHITE_LIST_MASTER,
      method: "POST",
      authToken: authToken,
      data: {
        branchCode: name,
        enabled: enabledSerive,
        whitelistedIps: whiteListIP,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };

  const handleDiscrepancySubmit = async (event) => {
    toastUpdate("", "", false);
    const isEnabled = enabledSerive === true || enabledSerive === "true";

  if (isEnabled) {
    const isAnyEmpty = whiteListIP.some((ip) => !ip.trim());
    if (isAnyEmpty) {
      toastUpdate(toastAction?.error, "All WhiteList IP fields must be filled.", true);
      return;
    }
  }

    let status = "";
    if (params.id) {
      status = await editInformation();
    } else {
      status = await saveInformation();
    }
    if (status === "SUCCESS") {
      const msg = params.id
        ? whiteListIPConfig?.editSuccess
        : whiteListIPConfig?.createSuccess;
      toastUpdate(toastAction?.success, msg, true);
      setRedirectURL(whiteListIPConfig?.mainUrl);
    }
  };

  const handleCancel = () => {
    navigate(whiteListIPConfig?.mainUrl);
  };

  const enabledService = (e) => {
    setEnabledService(e);
    if (e === "false" || e === false) {
      setWhiteListIP([""]);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.id ? whiteListIPConfig?.updateUser : whiteListIPConfig?.createLabel}
          button1=" Save"
          button2=" Cancel"
          button1click={handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Branch Name"
              id="name"
              value={name}
              setState={setName}
              data={branchCodeList}
              type="TYPE"
              disabled={params?.id}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Enabled*"
              id="dependancy"
              value={enabledSerive}
              setState={enabledService}
              data={activeServiceData}
              type="bool"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            {whiteListIP?.map((ip, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <CustomeTextField
                  label={
                    index === 0 ? "WhiteList IP" : `WhiteList IP ${index + 1}`
                  }
                  id={`whitelist_ip_${index}`}
                  value={ip}
                  setState={(value) => {
                    const newIPs = [...whiteListIP];
                    newIPs[index] = value;
                    setWhiteListIP(newIPs);
                  }}
                  type="notCapital"
                />
               {index === 0 ? (
                  <IconButton
                    aria-label="Add IP"
                    onClick={() => setWhiteListIP([...whiteListIP, ""])}
                    style={{ marginRight: -25, padding: 0 }}
                  >
                    <AddIcon />
                  </IconButton>
                ) : index === whiteListIP.length - 1 ? (
                  <IconButton
                    aria-label="Remove IP"
                    onClick={() => {
                      const newIPs = whiteListIP.filter((_, i) => i !== index);
                      setWhiteListIP(newIPs);
                    }}
                    style={{ marginRight: -25, padding: 0 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                ) : null}
              </div>
            ))}
          </Grid>
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default WhiteListIPMasterCreate;
